import { ShortcutAwareTooltip } from 'common/Prose/utils/ShortcutAwareTooltip'
import { Button } from './Button'
import { useUndoToggle } from 'common/Prose/Toolbar/hooks/useUndoToggle'
import { observer } from 'mobx-react-lite'
import { FlipLeft } from 'blaze-ui/icons'
import { Icon } from 'blaze-ui/icons/Types'

export const UndoButton = observer(({ icon = FlipLeft }: { icon?: Icon }) => {
  const { disabled, handleClick } = useUndoToggle()

  return (
    <ShortcutAwareTooltip label="Undo" shortcutKeys="z" shortcutModifiers={['Mod']}>
      <Button aria-label="Undo" icon={icon} isDisabled={disabled} onPress={handleClick} />
    </ShortcutAwareTooltip>
  )
})
